import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { DentalDisabilityMemoComponent } from './dental-disability-memo.component';

@NgModule({
  declarations: [
    DentalDisabilityMemoComponent
  ],
  imports: [
    SharedModule
  ],
  exports: [
    DentalDisabilityMemoComponent
  ]
})
export class DentalDisabilityMemoModule { }
